import Styled from './styled'

export default function privacyPolicyFixer({ data }) {
  const content = data?.privacyPolicyFixer?.description || ''

  return (
    <Styled>
      <div className="container">
        <div className="policy-content" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </Styled>
  )
}
